let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("32QYd")).then(() => parcelRequire('lWsj3'));